import { apiRequest } from './apiClient';
import { toEnglishDigits } from '../utils/numberUtils';

export async function loginWithPassword({ phone, password }) {
  const response = await apiRequest('/student/login', {
    method: 'POST',
    body: {
      phone: toEnglishDigits(phone).trim(),
      password: toEnglishDigits(password),
    },
  });

  return response.data;
}

export async function requestOtp({ phone }) {
  const response = await apiRequest('/student/otp/request', {
    method: 'POST',
    body: {
      phone: toEnglishDigits(phone).trim(),
    },
  });

  return response;
}

export async function verifyOtp({ phone, code }) {
  const response = await apiRequest('/student/otp/verify', {
    method: 'POST',
    body: {
      phone: toEnglishDigits(phone).trim(),
      code: toEnglishDigits(code).trim(),
    },
  });

  return response.data;
}
